import { Component, OnInit } from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import { AuthenicationService } from '../../_services/authenication.service';
import { PricesService } from "../../_services/prices.service";
import { ToasterService } from '../../_services/toaster.service';
import { DoctorService } from '../../_services/doctor.service';

declare var $: any;
import * as moment from 'moment';

@Component({
  selector: 'app-giftsessionlist',
  templateUrl: './giftsessionlist.component.html',
  styleUrls: ['./giftsessionlist.component.css']
})
export class GiftsessionlistComponent implements OnInit {

  userdetaild: string;
  returnUrl: string;
  promoCodeList: any[] = [];
  appointments: any[] = [];
  today : any;

  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute,private toaster: ToasterService, private pricesService: PricesService, private doctorservice: DoctorService) { }


    ngOnInit() {
      this.userdetaild = this.authenicationService.userDetails();
      if (!this.userdetaild) {
        this.router.navigate(['/login']);
      }
      if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
        this.router.navigate(['/']);
      }

      this.today = moment(new Date()).format("YYYY-MM-DD");
      this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

      this.getPromoCodeList();

    }

    getPromoCodeList() {
      this.pricesService.getGiftCode()
        .subscribe(
          (data: any) => {
            if (data && data.ResponseCode === '200') {
              this.promoCodeList = data.promoCodeList;
              setTimeout(()=>{
                $(function() {
                  $('#example').DataTable();
                });
              }, 1000);

            } else {
              this.toaster.showError('promoCodeList', data.ResponseMessage);
              setTimeout( () => {
                $(function () {
                  $('#example').DataTable();
                });
              }, 1000);
            }
          },
          error => {
            this.toaster.showError('promoCodeList', error);
            setTimeout( () => {
              $(function () {
                $('#example').DataTable();
              });
            }, 1000);
          });
    }

    showDetail(data) {
      const payload = {
        status: '',
        date: '',
        coupon_code:data
      };
      this.getAllAppointment(payload);
      $('#classModal').modal('show');
    }

    getAllAppointment(payload) {
      // this.doctorservice.listAllAppointment(payload)
      this.doctorservice.listAllAppointmentPagination(1,20,payload)
        .subscribe(
          (data: any) => {

            if (data && data.ResponseCode === '200') {
              //this.toaster.showSuccess('Appointments', data.ResponseMessage);
              this.appointments = data.DoctorAppointment;

            } else {
              this.appointments = [];
            }
            // this.router.navigate([this.returnUrl]);
          },
          error => {
             this.appointments = [];
          });
    }


}
